export default __webpack_public_path__ + "static/media/logo_technical_support.a66011d8.svg";